import React from 'react';
import './index.css';

export default function Header() {
    return (
        <header className='Header'>
            <div className='logo-1'>Losowanie</div>
            <div className='logo-2'>Świąteczne</div>
        </header>
    )
}